/**
 * Catálogo dos labs.
 *
 * Mora fora das páginas para que o índice e as rotas leiam a mesma lista. As
 * rotas indexam um mapa por `path`, então lab sem tela registrada não compila —
 * link apontando para 404 deixa de ser possível por construção, em vez de
 * depender de alguém lembrar de editar dois arquivos.
 */
export const PLAYGROUND_LABS = [
  {
    path: 'design-system',
    title: 'Design system',
    description: 'Paleta resolvida do tema, contraste medido e escala tipográfica.',
  },
  {
    path: 'icons',
    title: 'Ícones',
    description: 'Escala do componente Icon e o mapa de ícones do domínio.',
  },
  {
    path: 'brand',
    title: 'Marca',
    description: 'Símbolo animado, escala, loader, splash e comparação com o arquivo oficial.',
  },
  {
    path: 'animacoes',
    title: 'Animações',
    description: 'Selo de conclusão e stepper, com repetição, câmera lenta e quadro a quadro.',
  },
  {
    path: 'map-legend',
    title: 'Legenda do mapa',
    description: 'Os marcadores reais do mapa: forma, cor, tamanho, grupos, áreas e estados.',
  },
] as const satisfies readonly PlaygroundLab[];

export interface PlaygroundLab {
  /** Caminho relativo a `/playground`. */
  path: string;
  title: string;
  description: string;
}

/** União dos caminhos existentes, usada para exigir cobertura nas rotas. */
export type PlaygroundLabPath = (typeof PLAYGROUND_LABS)[number]['path'];
